import { render, staticRenderFns } from "./MobileFitNotices.vue?vue&type=template&id=6aaa1c61&scoped=true"
import script from "./MobileFitNotices.vue?vue&type=script&lang=js"
export * from "./MobileFitNotices.vue?vue&type=script&lang=js"
import style0 from "./MobileFitNotices.vue?vue&type=style&index=0&id=6aaa1c61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaa1c61",
  null
  
)

export default component.exports